'use strict';

const breakpoints = { small: 0, medium: 640, large: 1024 };


function initCarouselComponentSlot() {
    let carousels = $('.slot-carousel-wrapper .slots-carousel .slides'); // Seleziona solo i caroselli all'interno del wrapper

    carousels.each((id, el) => {
        let $el = $(el);
        let width = $(window).width();


        if (!$el.hasClass('owl-loaded')) { // Previeni doppia inizializzazione
            $el.owlCarousel({
                ...getSettingSlotCarousel(el),
                onInitialized: function () {
                    centerArrowImageLoad($el);
                    observeCarouselHeightChange($el);
                }
            });

            // In caso di infinite loop a false permette di far vedere metà tile a sinistra
            // quando si raggiunge l'ultima slide del carosello
            /*$el.on('changed.owl.carousel', (event) => {

                if($el.parents('.complete-your-look-wrapper').length > 0 && width <= breakpoints.medium){
                    var stage = $el.find('.owl-stage')

                    let currentIndex = parseInt(event.item.index); // Current Slide
                    let totalItems = parseInt(event.item.count); // Total Slides Number
                    let visibleItems = parseInt(event.page.size); // Number of visible slides

                    if (currentIndex + visibleItems >= totalItems) {
                        stage.addClass('no-right-padding');
                    } else {
                        stage.removeClass('no-right-padding');
                    }
                }
            });*/

            if($('.js-page').data('action') === 'Product-Show'){
                if($('.pdp-product-recommendations h5').length > 0){
                    $('.callout-recommendations').text($('.pdp-product-recommendations h5').html());
                    setTabWidth(el);
                    $('.pdp-carousels__callOuts').removeClass('hide');
                }
                if($('.pdp-recently-viewed h5').length > 0){
                    $('.callout-recently').text($('.pdp-recently-viewed h5').html());
                }
                changeCarouselsByTab();
            }

            if($el.parents('.complete-your-look-wrapper').length > 0){
                $el.parents('.complete-your-look-wrapper').removeClass('hide');
            }

            $el.trigger('refresh.owl.carousel');
        }
    });
}

function getSettingSlotCarousel(element) {
    let count = $(element).data('count').split('-');
    let isScrollable = $(element).data('scrollable');
    let productCount = $(element).children().length; // Conta i prodotti presenti
    let width = $(window).width();
    let marginValue = width >= breakpoints.large ? 40 : width >= breakpoints.medium ? 16 : 5;
    if(window.matchMedia("(orientation: landscape)").matches){
        marginValue = 16;
    }

    if($('.pdp-carousels__callOuts').length > 0){
        $('.pdp-carousels__callOuts').css('gap', `${marginValue}px`);
    }
    let stagePaddingValue = 0;
    //This code allows you to show a part fo the following slide
    /*if($(element).parents('.complete-your-look-wrapper').length > 0 && width <= breakpoints.medium){
        stagePaddingValue = 20;
    }*/

    var loopStatus = (productCount > 2 && width < breakpoints.medium) ||
        (productCount > 4 && width >= breakpoints.medium) ? true : false;

    return {
        loop: loopStatus,
        margin: marginValue,
        navText: ['', ''],
        mouseDrag: isScrollable,
        touchDrag: isScrollable,
        stagePadding: stagePaddingValue,
        responsive: {
            [breakpoints.small]: { nav: productCount > count[2], dots: true, items: count[2] },
            [breakpoints.medium]: { nav: productCount > count[1], dots: false, items: count[1] },
            [breakpoints.large]: { nav: productCount > count[0], dots: false, items: count[0] },
        },
    };
}

function centerCarouselArrows(element) {
    // Seleziona tutte le slide attive
    const activeSlide = $(element).find('.owl-item.active .image-container img');
    const prevArrow = $(element).find('.owl-prev');
    const nextArrow = $(element).find('.owl-next');

    if (activeSlide.length > 0 && prevArrow && nextArrow) {
        // Ottieni l'altezza della slide attiva
        const slideHeight = activeSlide[0].offsetHeight;
        const arrowHeight = prevArrow[0].offsetHeight;

        // Calcola la posizione top delle frecce
        const arrowPosition = (slideHeight / 2) + arrowHeight ;

        // Imposta la posizione top delle frecce
        prevArrow.css('top', `${arrowPosition}px`);
        nextArrow.css('top', `${arrowPosition}px`);
    }
}

function setTabWidth(element) {
    let width = $(window).width();
    if(width >= breakpoints.medium && $(element).parents('.pdp-carousels').length > 0 && !$(element).hasClass('owl-hidden')){
        const activeSlide = $(element).find('.owl-item.active .image-container img');

        if (activeSlide.length > 0) {
            // Ottieni la larghezza della slide attiva
            const slideWidth = activeSlide[0].offsetWidth;
            if(slideWidth != 0){
                $('.pdp-carousels__callOuts h5').css('width', `${slideWidth}px`);
            }

        }
    }

}

function observeCarouselLoad() {
    const observer = new MutationObserver(() => {
        if ($('.slot-carousel-wrapper .slots-carousel .slides').length > 0) {
            initCarouselComponentSlot();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}


function changeCarouselsByTab() {
    var pdpRecentlyViewedLength = $('.pdp-recently-viewed .slot-carousel-wrapper').length;
    var pdpRecommendationsLength = $('.pdp-product-recommendations .slot-carousel-wrapper').length;

    if (pdpRecommendationsLength > 0 && pdpRecentlyViewedLength > 0) {
        $('.pdp-carousels__callOuts .callout').on('click', function () {
            $('.callout').removeClass('active');
            $('.pdp-carousels .recommendations').removeClass('active');

            $(this).addClass('active');
            var activeClass = $(this).data('active-class');
            $('.pdp-carousels .' + activeClass).addClass('active');
        });

        $('.pdp-carousels__callOuts .callout-recently').removeClass('hide');
        $('.pdp-carousels .recommendations .grid-container').addClass('tab-structure');
    }else{
        $('.pdp-carousels__callOuts').addClass('hide');
        $('.pdp-carousels .recommendations .grid-container').removeClass('tab-structure');
    }

    if(pdpRecommendationsLength > 0 ){
        $('.pdp-product-recommendations').addClass('active');
        $('.pdp-recently-viewed').removeClass('active');
    } else if (pdpRecentlyViewedLength > 0 ){
        $('.pdp-recently-viewed').addClass('active');
        $('.pdp-product-recommendations').removeClass('active');
    }
}

//Observer per Resize window
function observeCarouselHeightChange(element) {
    const resizeObserver = new ResizeObserver(() => {
        centerCarouselArrows(element); // Riposizione le frecce se cambia altezza del carosello
        setTabWidth(element);
    });

    resizeObserver.observe(element[0]);
}

function centerArrowImageLoad(element) {

    const imageElement = element.find('.owl-item .image-container img');

    // evento di "load" per aspettare che l'immagine sia caricata e posizonare le frecce
    imageElement.on('load', function() {
        centerCarouselArrows(element);
        setTabWidth(element);
    });

    // se l'immagine è già caricata, posizona le frecce
    if (imageElement[0].complete) {
        centerCarouselArrows(element);
        setTabWidth(element);
    }
}

function initCarouselWithCorrectLoop() {
    let carousels = $('.slot-carousel-wrapper .slots-carousel .slides'); // Seleziona i caroselli

    carousels.each((id, el) => {
        let $el = $(el);
        if ($el.hasClass('owl-loaded')) { // Se il carosello è già stato inizializzato, distruggilo
            $el.trigger('destroy.owl.carousel');
        }

        let productCount = $(el).children().length; // Conta i prodotti nelle slide
        let width = $(window).width();

        // Calcola se attivare il loop in base alla larghezza
        var loopStatus = (productCount > 2 && width < breakpoints.medium) ||
        (productCount > 4 && width >= breakpoints.medium) ? true : false;

        // Inizializzazione del carosello con loop dinamico
        $el.owlCarousel(getSettingSlotCarousel(el, loopStatus));
    });
}

class CarouselSlot {
    run() {
        $(document).ready(() => {
            initCarouselComponentSlot(); // Inizializzazione iniziale
            observeCarouselLoad(); // Monitoraggio dei nuovi caroselli
        });

        if($('.js-page').data('action') === 'Search-Show' || $('.js-page').data('action') === 'Cart-Show'){
            $(window).on('resize orientationchange', function() {
                initCarouselWithCorrectLoop(); // Rinizializza il carosello con il loop corretto
            });
        }
    }
}

const carouselSlot = new CarouselSlot();
carouselSlot.run();



// WEBPACK FOOTER //
// ./assets/scripts/carouselSlot.js